import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
  standalone:false
})
export class FilterPipe implements PipeTransform {

 transform(items: any[], searchText: string, key?: string): any[] {
    if (!items || !searchText) {
      return items;
    }

    searchText = searchText.toLowerCase();

    return items.filter(item => {
      if (key) {
        // Filter by a specific key in the object
        return item[key]?.toLowerCase().includes(searchText);
      } else {
        // Filter by the item itself (assuming it's a string or has a default string representation)
        return item.toString().toLowerCase().includes(searchText);
      }
    });
  }

}
